<script setup lang="ts">
const { undismissedMessages, dismiss } = usePermanentMessages();
const { t } = useI18n();

function colorForType(type: string): 'warning' | 'error' | 'info' {
  if (type === 'error') return 'error';
  if (type === 'warning') return 'warning';
  return 'info';
}
</script>
<template>
  <div v-if="undismissedMessages.length > 0" class="flex flex-col mb-4 gap-2">
    <UAlert
      v-for="msg in undismissedMessages"
      :key="msg.dismissKey"
      :title="t(msg.titleKey, msg.params)"
      :icon="msg.icon"
      :color="colorForType(msg.type)"
      variant="subtle"
      close
      @update:open="dismiss(msg)"
    >
      <template #description>
        <span>{{ t(msg.messageKey, msg.params) }}</span>
        <UButton v-if="msg.action" :label="t(msg.action.labelKey)" variant="link" size="sm" class="ml-2" :to="msg.action.route" />
      </template>
    </UAlert>
  </div>
</template>
